import { jwtDecode } from "jwt-decode";

export enum JwtKeys {
  SUB = "sub",
  EMAIL = "email",
  ROLES = "roles",
  IAT = "iat",
  EXP = "exp",
}

export enum RoleType {
  USER = "USER",
  MANAGER = "MANAGER",
  ADMIN = "ADMIN",
}

interface JwtPayload {
  sub: string;
  email: string;
  roles?: string[];
  iat: number;
  exp?: number;
}

export const isTokenExpired = (token?: string): boolean => {
  if (!token) return true;

  try {
    const exp = getFromToken(token, JwtKeys.EXP);
    if (!exp) return true;

    const now = Math.floor(Date.now() / 1000);
    return exp < now;
  } catch {
    return true;
  }
};

export const getFromToken = <T extends JwtKeys>(
  token: string,
  key: T
): JwtPayload[T] | null => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded[key];
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const hasAnyRole = (token: string, requiredRoles: string[]): boolean => {
  const roles = getFromToken(token, JwtKeys.ROLES) || [];

  if (!Array.isArray(roles)) return false;

  return requiredRoles.some(role => roles.includes(role));
};
